import React, { type ComponentProps } from 'react';
import { Box } from '@fiverr-private/theme';
import { menuRow } from './CategoriesMenuPanel.ve.css';

interface MenuRowProps extends Omit<ComponentProps<typeof Box>, 'as' | 'backgroundColor'> {
    isSelected?: boolean;
}

export const MenuRow = ({ isSelected = false, children, className, ...props }: MenuRowProps) => (
    <Box
        as="button"
        type="button"
        className={className ? `${menuRow} ${className}` : menuRow}
        aria-current={isSelected ? 'true' : undefined}
        display="flex"
        alignItems="center"
        gap="3"
        width="100%"
        minHeight="56px"
        paddingX="3"
        paddingY="2"
        boxSizing="borderBox"
        borderWidth={0}
        borderRadius="xl"
        cursor="pointer"
        textAlign="start"
        backgroundColor={isSelected ? 'grey_200' : { default: 'transparent', hover: 'grey_200', active: 'grey_300' }}
        {...props}
    >
        {children}
    </Box>
);
